import React from 'react';
import { useTranslate } from 'react-admin';
import { ResourceFormDialog } from '@/components/common';
import DefaultPricingForm from './DefaultPricingForm';
import { createEmptyDefaultPricingFormValues } from '../constants';

export interface DefaultPricingFormDialogProps {
  open: boolean;
  onClose: () => void;
  recordId: string | number | null;
}

export const DefaultPricingFormDialog: React.FC<
  DefaultPricingFormDialogProps
> = ({ open, onClose, recordId }) => {
  const translate = useTranslate();
  const isEdit = recordId !== null;
  return (
    <ResourceFormDialog
      open={open}
      onClose={onClose}
      mode={isEdit ? 'edit' : 'create'}
      resource="default-pricing"
      recordId={recordId ?? undefined}
      title={translate('resources.default-pricing.dialog.title')}
      createRecord={!isEdit ? createEmptyDefaultPricingFormValues() : undefined}
      createdMessage="resources.default-pricing.notifications.created"
      updatedMessage="resources.default-pricing.notifications.updated"
      maxWidth="md"
    >
      <DefaultPricingForm />
    </ResourceFormDialog>
  );
};

export default DefaultPricingFormDialog;
